module.exports = __webpack_public_path__ + "img/logo_rgb_color.e7b13d46.png";